export const FACEBOOK_URL = "https://www.facebook.com/share/1BysBnbzi8/";
export const MESSENGER_URL = "https://www.facebook.com/share/1BysBnbzi8/";
export const GOOGLE_REVIEW_URL = "https://g.page/r/CV8_Kq8RsE6GEAE/review";
